var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRiuqDeZt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 34,
    viewBox: "0 0 35 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    stroke: "#32239B",
    d: "M12.533 29.183c0 1.553 1.272 2.817 2.834 2.817h2.266c1.562 0 2.833-1.264 2.833-2.817V27.14c0-1.748.72-3.421 2.025-4.712C24.11 20.833 25 18.709 25 16.45c0-4.706-3.882-8.531-8.65-8.45-4.437.075-8.181 3.725-8.344 8.133-.087 2.336.773 4.543 2.423 6.216 1.357 1.375 2.104 3.08 2.104 4.797v2.036zM13 27.5L20 27.5",
    transform: "translate(-920 -785) translate(921 786)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#22BF76",
    d: "M16.5 0L16.5 3M0 16.5L3 16.5M30 16.5L33 16.5M5 5L7 7M26 7L28 5",
    transform: "translate(-920 -785) translate(921 786)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#32239B",
    d: "M16.5 18L16.5 27M16.481 14.453l.091.096-.09-.096z",
    transform: "translate(-920 -785) translate(921 786)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRiuqDeZt);
export default __webpack_public_path__ + "static/media/RiuqDeZT.6d3aad63f0d6d3b110d1b204951215d2.svg";
export { ForwardRef as ReactComponent };